const state = {
  applicable_id: null,
  product: null,
  fetchData: false
}

const getters = {
  fetchData: state => state.fetchData
}

const mutations = {
  setRejectApplicant (state, { id, product }) {
    state.applicable_id = id
    state.product = product
    state.fetchData = !state.fetchData
  }
}

const actions = {
  setRejectApplicant ({ commit }, { id, product }) {
    commit('setRejectApplicant', { id, product })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
